import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';
import { monetaryAmountFragment } from '@sorare/core/src/lib/monetaryAmount';

import type { useSortPrimaryBuys_anyCard } from './__generated__/useSortPrimaryBuys.graphql';

type Props<T extends useSortPrimaryBuys_anyCard> = {
  anyCards?: T[];
};
export const useSortPrimaryBuys = <T extends useSortPrimaryBuys_anyCard>({
  anyCards = [],
}: Props<T>): T[] => {
  const { toMonetaryAmount } = useMonetaryAmount();

  const sortedCards = [...anyCards]?.sort((cardA, cardB) => {
    if (cardA?.latestPrimaryOffer?.price && cardB?.latestPrimaryOffer?.price) {
      const priceA = toMonetaryAmount(cardA.latestPrimaryOffer.price);
      const priceB = toMonetaryAmount(cardB.latestPrimaryOffer.price);
      return priceA.eur - priceB.eur;
    }
    return 0;
  });

  return sortedCards;
};

useSortPrimaryBuys.fragments = {
  anyCard: gql`
    fragment useSortPrimaryBuys_anyCard on AnyCardInterface {
      slug
      latestPrimaryOffer {
        id
        price {
          ...MonetaryAmountFragment_monetaryAmount
        }
      }
    }
    ${monetaryAmountFragment}
  ` as TypedDocumentNode<useSortPrimaryBuys_anyCard>,
};
